import { useEffect } from "react";
import { Mail, Phone, MapPin, MessageCircle, Linkedin } from "lucide-react";
import ContactForm from "@/components/sections/ContactForm";

export default function Contact() {
  useEffect(() => {
    document.title = "Contato — Áxis Saúde Digital";
  }, []);

  return (
    <div data-testid="contact-page" className="bg-white">
      <section className="pt-16 lg:pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Info */}
          <aside className="lg:col-span-5">
            <p className="font-mono-axis text-xs uppercase tracking-widest text-[#1E3A8A] mb-4">
              Fale com a Áxis
            </p>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-semibold text-[#111827] leading-[1.05]">
              Vamos <span className="text-[#1E3A8A]">construir</span> juntos.
            </h1>
            <p className="mt-6 text-base md:text-lg text-gray-600 leading-relaxed">
              Nossa equipe consultiva retorna em até 1 dia útil. Para casos
              urgentes, utilize o WhatsApp abaixo.
            </p>

            <ul className="mt-12 space-y-6">
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 border border-gray-200 flex items-center justify-center">
                  <Mail className="w-4 h-4 text-[#1E3A8A]" />
                </div>
                <div>
                  <p className="font-mono-axis text-xs uppercase tracking-widest text-gray-500">
                    E-mail
                  </p>
                  <a
                    href="mailto:contato@axissaudedigital.com.br"
                    className="text-base font-medium text-[#111827] hover:text-[#1E3A8A] transition-colors"
                    data-testid="contact-email-link"
                  >
                    contato@axissaudedigital.com.br
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 border border-gray-200 flex items-center justify-center">
                  <Phone className="w-4 h-4 text-[#1E3A8A]" />
                </div>
                <div>
                  <p className="font-mono-axis text-xs uppercase tracking-widest text-gray-500">
                    Telefone
                  </p>
                  <p className="text-base font-medium text-[#111827]">
                    +55 (00) 00000-0000
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-10 h-10 border border-gray-200 flex items-center justify-center">
                  <MapPin className="w-4 h-4 text-[#1E3A8A]" />
                </div>
                <div>
                  <p className="font-mono-axis text-xs uppercase tracking-widest text-gray-500">
                    Atendimento
                  </p>
                  <p className="text-base font-medium text-[#111827]">
                    Nacional · Presencial e remoto
                  </p>
                </div>
              </li>
            </ul>

            <div className="mt-12">
              <p className="font-mono-axis text-xs uppercase tracking-widest text-gray-500 mb-4">
                Canais diretos
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="https://wa.me/5500000000000"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-whatsapp"
                  aria-label="WhatsApp"
                  className="inline-flex items-center gap-2 px-4 py-3 border border-gray-200 hover:border-[#1E3A8A] hover:text-[#1E3A8A] text-sm font-medium transition-colors"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp
                </a>
                <a
                  href="https://linkedin.com/company/axis-saude-digital"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-linkedin"
                  aria-label="LinkedIn"
                  className="inline-flex items-center gap-2 px-4 py-3 border border-gray-200 hover:border-[#1E3A8A] hover:text-[#1E3A8A] text-sm font-medium transition-colors"
                >
                  <Linkedin className="w-4 h-4" />
                  LinkedIn
                </a>
                <a
                  href="mailto:contato@axissaudedigital.com.br"
                  data-testid="contact-mail"
                  aria-label="E-mail"
                  className="inline-flex items-center gap-2 px-4 py-3 border border-gray-200 hover:border-[#1E3A8A] hover:text-[#1E3A8A] text-sm font-medium transition-colors"
                >
                  <Mail className="w-4 h-4" />
                  E-mail
                </a>
              </div>
            </div>
          </aside>

          {/* Form */}
          <div className="lg:col-span-7">
            <div className="bg-white border border-gray-200 p-8 lg:p-12">
              <h2 className="font-display text-2xl lg:text-3xl font-medium tracking-tight text-[#111827] mb-8">
                Solicite sua demonstração
              </h2>
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
